export const addDays = (date: any, days: any) => {
  const daysCalculated = calculateDaysAsInteger(days);
  const newDate = new Date(Number(date));
  newDate.setDate(date.getDate() + daysCalculated);
  return newDate;
};

export const calculateDaysAsInteger = (days: any) => {
  return typeof days === 'string' ? parseInt(days) : days;
}

export const dateFormat = (initialDate: Date, finalDate: Date) => {
  return isTheSameMonthBetweenDates(initialDate, finalDate) ? 'd' : 'MMMM d';
}

export const isTheSameMonthBetweenDates = (initialDate: Date, finalDate: Date) => {
  return initialDate.getMonth() === finalDate.getMonth();
}

  export const formatDateWithoutDashes = (date: string): string => {
    return date ? date.replace(/-/g, '') : '';
  }
